
import { getImageUrl } from "config/apiUrls";
import { ArticleExtraData } from "../../../../../articlePage/stateInterfaces";
import { getTranslation } from "../../autoTickerRowWidget/autoTickerRowTranslations";
import { DateDisplay } from "../../../../commonComponents/inline/dateDisplay/dateDisplay";
import { isWcmEditor } from "../../../../../config/serverConfig";
import { NewsFlashShareMenu } from "../../newsflashAndTwentyFourSeven/components/newsFlashSpecial/newsFlashShareMenu";
import { useEffect, useState, useRef, useCallback } from "react";
import { minutesDiff } from "../../newsflashAndTwentyFourSeven/components/newsFlashSpecial/desktop/newsFlashSpecialDesktopComponent";
import { SiteVideoInline } from "../../../../siteWidgets/videoPlayer/genericInlineVideoPlayer/siteVideoInline";
import { SiteVideoData } from "../../../../interfaces";
import { MediaContentTypes } from "../../../../../constants/contentTypes";
import { VideoBehaiforData } from "../../../../commonDataObjects/interfaces";
import { SpeedMenuButton } from "../../../verticalVideoOverlayPlayer/components/SpeedMenuButton";

interface FlashPageSpecialItemProps {
    isLTR: boolean
    article: ArticleExtraData
    nextRoof: string
    languageCode: string
    previousRoof: string
    roofOngoingEvent: boolean
    index?: number
    accordionOpenState?: boolean
    onToggle?: () => void
    openMediaDisplayView?: (videoIndex: number) => void
    handleCarouselAutoplay?: (shouldCarouselAutoplay: boolean) => void
}

const HIGHLIGHT_DURATION = 1;

export const FlashPageSpecialItem = (props: FlashPageSpecialItemProps) => {

    const { index, article, languageCode, isLTR, nextRoof, previousRoof, roofOngoingEvent, accordionOpenState, onToggle, openMediaDisplayView } = props;
    const { articleId, roof, title, dateUpdatedOnSite, plainText, author, specialData, category, video, publishedLink, promotionImageDetails } = article;
    const { mediaLinkType } = specialData;
    const [isExpandOpen, setIsExpandOpen] = useState<boolean>(accordionOpenState || false);
    const [isVideoStarted, setIsVideoStarted] = useState(false);
    const [isMuted, setIsMuted] = useState(true);
    const [autoPlayVideo, setAutoPlayVideo] = useState(false);
    const playerApiRef = useRef(null) as any;

    useEffect(() => {
        setIsExpandOpen(accordionOpenState);
    }, [accordionOpenState]);

    useEffect(() => {
        if (!isExpandOpen) {
            setIsVideoStarted(false);
            setAutoPlayVideo(false);
        }
    }, [isExpandOpen]);

    const handlePlayerLoaded = useCallback((player: any) => {
        playerApiRef.current = player;
    }, []) as (player: any) => void;

    const handlePlayStarted = useCallback(() => {
        setIsVideoStarted(true);
    }, []) as () => void;

    const handleMuteToggle = (e: React.MouseEvent) => {
        e.stopPropagation();
        const player = playerApiRef.current;
        if (player) {
            player.muted = !player.muted;
            setIsMuted(player.muted);
        }
    };

    const dispatchCustomEvent = (titleText: string, currentOpen: boolean) => {
        document.dispatchEvent(
            new CustomEvent("newsFlashesTwentyFourSevenReadMoreChange",
                {
                    detail: {
                        action: currentOpen ? "Collapse" : "Expand",
                        label: titleText,
                    }
                }
            ))
    }

    const onSlotClickHandler = () => {
        if (!isExpandOpen) {
            setAutoPlayVideo(true);
        }
        dispatchCustomEvent(title, isExpandOpen);
        if (onToggle) {
            onToggle();
        } else {
            setIsExpandOpen(!isExpandOpen);
        }
    }

    const newItem = minutesDiff(article) < HIGHLIGHT_DURATION;
    const isNewItem = newItem ? "now" : "";
    const isOpen = isExpandOpen ? "open" : "";
    const hasRoof = roof && roof.length > 0 ? "has-roof" : "";
    const lang = languageCode ? languageCode.slice(0, 2) : "he";
    const date = newItem ? getTranslation(lang, "Now") : <DateDisplay date={dateUpdatedOnSite} isMinutesAgo={true} isArticle={true} />;
    const isAuthor = author && author.length > 0;
    const mediaId = !isWcmEditor() && mediaLinkType === "video" && video && video[0] && video[0].mediaVideoId ? video[0].mediaVideoId : "";
    const enlargedPosterUrl = getPosterUrl(article, true);
    const isVideo = mediaLinkType === "video" && video && video[0];
    const videoData = isVideo ? buildVideoData(article, autoPlayVideo) : null;
    const isPortrait = specialData.mediaProportion === "9:16";
    const mediaCredit = mediaLinkType === "video" ? video && video[0] && video[0].credit ? video[0].credit : undefined : promotionImageDetails && promotionImageDetails.credit ? promotionImageDetails.credit : undefined;
    // const isFirstRoofInSequence = !roofOngoingEvent ? true : previousRoof !== roof;
    // const shouldShowConnectorLine = roofOngoingEvent && roof && nextRoof === roof;

    return (
        <div className={`special-page-flash-item ${isOpen} ${isNewItem} ${hasRoof}`} data_analytics_id={articleId}>
            <div className="flash-content">
                <div className="slotInfo" onClick={onSlotClickHandler}>
                    {/* { roof && isFirstRoofInSequence &&
                        <div className="roof-sequence-indication">
                            <div className="dot"></div>
                            <div className="roof-connector-line" />
                        </div>
                    } */}

                    {!isOpen && mediaLinkType !== "none" && mediaLinkType !== undefined &&
                        <div className={`image-container ${isPortrait ? "portrait" : ""}`} data_mediaid_analitycs={mediaId}>
                            <img className="posterImage" src={getPosterUrl(article, false)} alt={title} />
                            {mediaLinkType === "video" && <div className="video-icon"></div>}
                            {mediaLinkType === "image" && <div className="expand-image-icon"></div>}
                        </div>
                    }

                    <div className="slotInfoText">
                        {roof && <span className="roofTitle">{roof}</span>}

                        <div className="slotTitle">{title}</div>

                        {!isOpen && <div className="dateView">{date}</div>}
                    </div>
                </div>

                <div className={`slotContent ${isOpen ? "show" : ""}`}>
                    {hasMedia(article) && enlargedPosterUrl &&
                        <div className={`enlarged-media ${isPortrait ? "portrait" : ""}`} data_mediaid_analitycs={mediaId} onClick={(e) => e.stopPropagation()}>
                            {isExpandOpen && isVideo && videoData ?
                                <>
                                    <SiteVideoInline
                                        data={videoData}
                                        hideVideoAds={true}
                                        applyStickyness={false}
                                        onPlayStarted={handlePlayStarted}
                                        onPlayerLoaded={handlePlayerLoaded}
                                    />

                                    {isVideoStarted &&
                                        <div className="video-controls-overlay">
                                            <div className={`mute-btn ${isMuted ? "muted" : ""}`} onClick={handleMuteToggle}></div>

                                            <SpeedMenuButton playerApiRef={playerApiRef} />
                                        </div>
                                    }
                                </>
                                :
                                <img src={enlargedPosterUrl} alt={title} />
                            }
                        </div>
                    }

                    <div className="slotText" onClick={onSlotClickHandler}>
                        {plainText}

                        {isAuthor && <div className="author">{`(${author}${mediaCredit ? `, ${mediaCredit}` : ""})`}</div>}

                        <div className="dateView">{date}</div>
                    </div>
                </div>
            </div>

            <NewsFlashShareMenu
                isDefaultOpen
                title={title}
                articleId={articleId}
                shareUrl={publishedLink}
                isNew={isNewItem === "now"}
                className={isExpandOpen ? "show-share" : "hide-share"}
            />
        </div>
    )
}

const getPosterUrl = (article: ArticleExtraData, enlarged: boolean = false): string => {
    const { specialData, promotionImageDetails, video } = article;
    if (!specialData) return "";
    const { mediaLinkType, mediaProportion } = specialData;
    const size = enlarged
        ? mediaProportion === "9:16" ? { w: 426, h: 757 } : { w: 610, h: 345 }
        : mediaProportion === "9:16" ? { w: 207, h: 370 } : { w: 448, h: 251 };

    if (mediaLinkType !== "none" && mediaLinkType !== undefined) {
        if (mediaLinkType === "image") {
            return getImageUrl(promotionImageDetails, size);
        } else if (mediaLinkType === "video") {
            if (video && video[0] && video[0].posterSrc) {
            return video[0].posterSrc;
            }
            else return getImageUrl(promotionImageDetails, size);

        }
    }
    return "";
}

const hasMedia = (article: ArticleExtraData): boolean => {
    if (!article.specialData) return false;
    const { mediaLinkType } = article.specialData;
    return mediaLinkType !== "none" && mediaLinkType !== undefined;
}

const buildVideoData = (article: ArticleExtraData, autoPlay: boolean): SiteVideoData | null => {
    const { video, title, specialData } = article;
    if (!video || !video[0]) return null;
    const { videoCredit, videoOriginalCaption } = specialData;

    const VideoBehavior: VideoBehaiforData = {
        isAutoPlaying: autoPlay,
        isLoopPlaying: false,
        isPlayerBarVisible: true,
        isSoundButtonVisible: true,
        isMuteAvailable: true,
    };

    return {
        ...VideoBehavior,
        mediaType: MediaContentTypes.MEDIA_VIDEO,
        mediaId: video[0].mediaVideoId,
        credit: videoCredit || "",
        url: video[0].main_link,
        downGradeUrl: video[0].low_res_link,
        title: title || videoOriginalCaption || "",
        poster: video[0].posterSrc,
        duration: video[0].duration,
        youtube_id: video[0].youtube_id,
        blockAbroadViews: false,
    } as SiteVideoData;
}